<div class="email-communication-container display-block text-center">
    <div class="font-20 font-bold">
        Firebase Error
    </div>
    <div class="margin-top font-14">
        Firebase remote config failed to load. Check console for logs and try again later.
    </div>
</div>